import type { PostAccessAuthenticateBody } from '@bond/bruce-api/api/access/authenticate/body'
import { z } from 'zod'

export const loginSchema = z.object({
  email: z.string().email(),
  password: z.string().min(1, { message: 'Password is required' }),
  '2fa_token': z.string().optional(),
}) satisfies z.ZodType<Omit<PostAccessAuthenticateBody, 'authenticator'>>

export const appleLoginSchema = z.object({
  apple_token: z.string(),
  first_name: z.string().optional(),
  last_name: z.string().optional(),
}) satisfies z.ZodType<Omit<PostAccessAuthenticateBody, 'authenticator'>>

export const googleLoginSchema = z.object({
  google_token: z.string(),
}) satisfies z.ZodType<Omit<PostAccessAuthenticateBody, 'authenticator'>>
